import type { UserType } from "@/types/graphql/partner.generated";

export function mapUserToFormValues(
  user: UserType | null | undefined
): Record<string, unknown> {
  if (!user) {
    return {
      firstName: "",
      lastName: "",
      country: null,
      language: "ru",
      timeZone: null,
      currentOrganizationId: null,
      agreeToMarketingNewsletters: false,
    };
  }

  return {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    country: user.country || null,
    language: user.language || "ru",
    timeZone: user.timeZone || null,
    currentOrganizationId: user.currentOrganizationId || null,
    agreeToMarketingNewsletters: user.agreeToMarketingNewsletters || false,
  };
}
